// Description: Component to signup in desktop 
// Updated: 02/09/2025
// Author: Simon Franklin

// React
import React, { useState } from 'react';

// Material UI Components
import { Grid, Box, Typography, TextField, Button, Checkbox, FormControlLabel, SvgIcon } from '@mui/material';
import ThemeColors from '../../components/ThemeColors/ThemeColors';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { notify } from '../../utils/utils';

export function FacebookIcon() {
    return (
        <SvgIcon>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.68 15.92C2.88 15.24 0 11.96 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 11.96 13.12 15.24 9.32 15.92L8.88 15.56H7.12L6.68 15.92Z"
                    fill="url(#paint0_linear_795_116)"
                />
                <path
                    d="M11.12 10.2391L11.48 7.99914H9.36V6.43914C9.36 5.79914 9.6 5.31914 10.56 5.31914H11.6V3.27914C11.04 3.19914 10.4 3.11914 9.84 3.11914C8 3.11914 6.72 4.23914 6.72 6.23914V7.99914H4.72V10.2391H6.72V15.8791C7.16 15.9591 7.6 15.9991 8.04 15.9991C8.48 15.9991 8.92 15.9591 9.36 15.8791V10.2391H11.12Z"
                    fill="white"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_795_116"
                        x1="8"
                        y1="0"
                        x2="8"
                        y2="15.9991"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#1AAFFF" />
                        <stop offset="1" stopColor="#0163E0" />
                    </linearGradient>
                </defs>
            </svg>
        </SvgIcon>
    );
}

export function GoogleIcon() {
    return (
        <SvgIcon>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54545H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z"
                    fill="#4285F4"
                />
                <path
                    d="M8 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98545 12.5309 9.07636 12.8218 8 12.8218C5.92 12.8218 4.15273 11.4182 3.52 9.52727H0.858182V11.5927C2.17455 14.2036 4.87273 16 8 16Z"
                    fill="#34A853"
                />
                <path
                    d="M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.46909 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70545 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z"
                    fill="#FBBC05"
                />
                <path
                    d="M8 3.18545C9.17818 3.18545 10.2255 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 8 0C4.87273 0 2.17455 1.79636 0.858182 4.41455L3.52 6.48C4.15273 4.58909 5.92 3.18545 8 3.18545Z"
                    fill="#EA4335"
                />
            </svg>
        </SvgIcon>
    );
}

const Form = ({ username, setUsername, password, setPassword, message, loading, checked, handleChange, handleSubmit, email, setEmail, confirmPassword, setConfirmPassword, setMessage }) => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleFacebookLogin = () => {
        const popupURL =
            `${process.env.REACT_APP_COGNITO_URL}/oauth2/authorize?` +
            'identity_provider=Facebook' +
            '&response_type=code' +
            `&client_id=${process.env.COGNITO_CLIENT_ID}` +
            `&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}/callback`

        window.location.href = popupURL;
    };

    const handleGoogleLogin = () => {
        const popupURL =
            `${process.env.REACT_APP_COGNITO_URL}/oauth2/authorize?` +
            'identity_provider=Google' +
            '&response_type=code' +
            `&client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}` +
            `&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}/callback`

        window.location.href = popupURL;
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        padding: '10px',
                        background: message === 'Senha alterada com sucesso.' ? '#D3F8D3' : message ? '#F8D6D3' : 'transparent',
                        marginBottom: '10px',
                        marginTop: '-40px',
                        borderRadius: '10px',
                    }}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_34_1183" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                <rect width="20" height="20" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_34_1183)">
                                <path fill={message === 'Senha alterada com sucesso.' ? 'rgb(47 120 60)' : message ? '#CD4747' : 'transparent'} d="M8 10.9743C8.11622 10.9743 8.21367 10.935 8.29233 10.8563C8.371 10.7778 8.41033 10.6804 8.41033 10.5642C8.41033 10.4478 8.371 10.3504 8.29233 10.2718C8.21367 10.1932 8.11622 10.1538 8 10.1538C7.88378 10.1538 7.78633 10.1932 7.70767 10.2718C7.629 10.3504 7.58967 10.4478 7.58967 10.5642C7.58967 10.6804 7.629 10.7778 7.70767 10.8563C7.78633 10.935 7.88378 10.9743 8 10.9743ZM7.66667 8.76917H8.33333V4.76917H7.66667V8.76917ZM8.00217 14C7.1725 14 6.39244 13.8426 5.662 13.5277C4.93167 13.2128 4.29633 12.7854 3.756 12.2457C3.21567 11.7059 2.78794 11.0711 2.47283 10.3413C2.15761 9.61167 2 8.83194 2 8.00217C2 7.1725 2.15744 6.39244 2.47233 5.662C2.78722 4.93167 3.21456 4.29633 3.75433 3.756C4.29411 3.21567 4.92889 2.78794 5.65867 2.47283C6.38833 2.15761 7.16806 2 7.99783 2C8.8275 2 9.60756 2.15744 10.338 2.47233C11.0683 2.78722 11.7037 3.21456 12.244 3.75433C12.7843 4.29411 13.2121 4.92889 13.5272 5.65867C13.8424 6.38833 14 7.16806 14 7.99783C14 8.8275 13.8426 9.60756 13.5277 10.338C13.2128 11.0683 12.7854 11.7037 12.2457 12.244C11.7059 12.7843 11.0711 13.2121 10.3413 13.5272C9.61167 13.8424 8.83194 14 8.00217 14Z" />
                            </g>
                        </svg>
                        <Typography style={{ color: message === 'Senha alterada com sucesso.' ? 'rgb(47 120 60)' : message ? '#CD4747' : 'transparent', fontSize: '12px', fontFamily: 'Satoshi', marginLeft: '10px' }}>
                            {message}
                        </Typography>
                    </div>
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ width: '100%', backgroundColor: '#fff', padding: { xs: '40px', lg: '32px' }, borderRadius: '12px', border: '1px solid #DBDBDB', maxWidth: '430px', boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.08)" }}>
                        <Typography sx={{ color: ThemeColors.purple500, fontSize: { xs: '24px', lg: '30px' }, fontFamily: 'Satoshi-Medium', fontWeight: 500 }}>Crie sua conta</Typography>
                        <Typography sx={{ color: '#52525B', fontSize: '14px', fontFamily: 'Satoshi', marginTop: '8px', marginBottom: 0 }}>Nome de usuário</Typography>
                        <TextField
                            variant="outlined"
                            placeholder='Nome de usuário'
                            fullWidth
                            margin="normal"
                            name="username"
                            value={username}
                            autoFocus={true}
                            size="small"
                            onChange={(e) => {
                                let value = e.target.value.toLowerCase();

                                if (value.length === 1 && !/^[a-zA-Z]/.test(value)) {
                                    notify("Alert", "O nome de usuário deve começar com uma letra.", true);
                                    return;
                                }

                                if (/[^a-z0-9-_]/.test(value)) {
                                    notify("Alert", "Use apenas letras, números, hífens ou underscores.", true);
                                    return;
                                }

                                if (value.length > 20) {
                                    notify("Alert", "O nome de usuário deve ter no máximo 20 caracteres.", true);
                                    return;
                                }

                                setUsername(value);
                            }}
                            sx={{ '& .css-1qb9py0-MuiInputBase-root-MuiOutlinedInput-root': { background: message === 'Esse email ou usuário é inválido.' || (message === 'Por favor, preencha todos os campos.' && username === '') || message === 'Usuário ou senha inválidos.' ? '#F8D6D3' : '#F9F9F9' }, marginTop: '5px', marginBottom: { xs: '8px', lg: '5px' }, borderRadius: '4px' }}
                            InputProps={{
                                endAdornment: (
                                    message === 'Esse email ou usuário é inválido.' || (message === 'Por favor, preencha todos os campos.' && username === '') || message === 'Usuário ou senha inválidos.' ?
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_34_1183" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                                <rect width="20" height="20" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_34_1183)">
                                                <path d="M8 10.9743C8.11622 10.9743 8.21367 10.935 8.29233 10.8563C8.371 10.7778 8.41033 10.6804 8.41033 10.5642C8.41033 10.4478 8.371 10.3504 8.29233 10.2718C8.21367 10.1932 8.11622 10.1538 8 10.1538C7.88378 10.1538 7.78633 10.1932 7.70767 10.2718C7.629 10.3504 7.58967 10.4478 7.58967 10.5642C7.58967 10.6804 7.629 10.7778 7.70767 10.8563C7.78633 10.935 7.88378 10.9743 8 10.9743ZM7.66667 8.76917H8.33333V4.76917H7.66667V8.76917ZM8.00217 14C7.1725 14 6.39244 13.8426 5.662 13.5277C4.93167 13.2128 4.29633 12.7854 3.756 12.2457C3.21567 11.7059 2.78794 11.0711 2.47283 10.3413C2.15761 9.61167 2 8.83194 2 8.00217C2 7.1725 2.15744 6.39244 2.47233 5.662C2.78722 4.93167 3.21456 4.29633 3.75433 3.756C4.29411 3.21567 4.92889 2.78794 5.65867 2.47283C6.38833 2.15761 7.16806 2 7.99783 2C8.8275 2 9.60756 2.15744 10.338 2.47233C11.0683 2.78722 11.7037 3.21456 12.244 3.75433C12.7843 4.29411 13.2121 4.92889 13.5272 5.65867C13.8424 6.38833 14 7.16806 14 7.99783C14 8.8275 13.8426 9.60756 13.5277 10.338C13.2128 11.0683 12.7854 11.7037 12.2457 12.244C11.7059 12.7843 11.0711 13.2121 10.3413 13.5272C9.61167 13.8424 8.83194 14 8.00217 14Z" fill="#CD4747" />
                                            </g>
                                        </svg>
                                        : null
                                )
                            }}
                        />
                        <Typography sx={{ color: '#52525B', fontSize: '14px', fontFamily: 'Satoshi', marginTop: '8px', marginBottom: 0 }}>Email</Typography>
                        <TextField
                            variant="outlined"
                            placeholder='Email'
                            fullWidth
                            margin="normal"
                            name="Email"
                            value={email}
                            type='email'
                            size="small"
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ '& .css-1qb9py0-MuiInputBase-root-MuiOutlinedInput-root': { background: message === 'Esse email ou usuário é inválido.' || (message === 'Por favor, preencha todos os campos.' && username === '') || message === 'Usuário ou senha inválidos.' ? '#F8D6D3' : '#F9F9F9' }, marginTop: '5px', marginBottom: { xs: '8px', lg: '5px' }, borderRadius: '4px' }}
                            InputProps={{
                                endAdornment: (
                                    message === 'Esse email ou usuário é inválido.' || (message === 'Por favor, preencha todos os campos.' && username === '') || message === 'Usuário ou senha inválidos.' ?
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_34_1183" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                                <rect width="20" height="20" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_34_1183)">
                                                <path d="M8 10.9743C8.11622 10.9743 8.21367 10.935 8.29233 10.8563C8.371 10.7778 8.41033 10.6804 8.41033 10.5642C8.41033 10.4478 8.371 10.3504 8.29233 10.2718C8.21367 10.1932 8.11622 10.1538 8 10.1538C7.88378 10.1538 7.78633 10.1932 7.70767 10.2718C7.629 10.3504 7.58967 10.4478 7.58967 10.5642C7.58967 10.6804 7.629 10.7778 7.70767 10.8563C7.78633 10.935 7.88378 10.9743 8 10.9743ZM7.66667 8.76917H8.33333V4.76917H7.66667V8.76917ZM8.00217 14C7.1725 14 6.39244 13.8426 5.662 13.5277C4.93167 13.2128 4.29633 12.7854 3.756 12.2457C3.21567 11.7059 2.78794 11.0711 2.47283 10.3413C2.15761 9.61167 2 8.83194 2 8.00217C2 7.1725 2.15744 6.39244 2.47233 5.662C2.78722 4.93167 3.21456 4.29633 3.75433 3.756C4.29411 3.21567 4.92889 2.78794 5.65867 2.47283C6.38833 2.15761 7.16806 2 7.99783 2C8.8275 2 9.60756 2.15744 10.338 2.47233C11.0683 2.78722 11.7037 3.21456 12.244 3.75433C12.7843 4.29411 13.2121 4.92889 13.5272 5.65867C13.8424 6.38833 14 7.16806 14 7.99783C14 8.8275 13.8426 9.60756 13.5277 10.338C13.2128 11.0683 12.7854 11.7037 12.2457 12.244C11.7059 12.7843 11.0711 13.2121 10.3413 13.5272C9.61167 13.8424 8.83194 14 8.00217 14Z" fill="#CD4747" />
                                            </g>
                                        </svg>
                                        : null
                                )
                            }}
                        />
                        <Typography sx={{ color: '#52525B', fontSize: '14px', fontFamily: 'Satoshi', marginTop: '8px', marginBottom: 0 }}>Senha</Typography>
                        <Box position='relative'>
                            <Box
                                sx={{
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    zIndex: '10',
                                    top: '50%',
                                    right: '33px',
                                    transform: 'translateY(-50%)'
                                }}
                                onClick={() => setShowPassword(prev => !prev)}
                            >
                                {showPassword ? <VisibilityOffIcon sx={{ fill: 'gray', width: "16px", height: "16px" }} /> : <VisibilityIcon sx={{ fill: 'gray', width: "16px", height: "16px" }} />}
                            </Box>
                            <TextField
                                placeholder='Senha'
                                type={showPassword ? "text" : "password"}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                sx={{ '& .css-1qb9py0-MuiInputBase-root-MuiOutlinedInput-root': { background: message === 'Usuário ou senha inválidos.' || message === 'As senhas não estão iguais.' || (message === 'Por favor, preencha todos os campos.' && password === '') ? '#F8D6D3' : '#F9F9F9' }, marginTop: '5px', marginBottom: { xs: '8px', lg: '5px' }, borderRadius: '4px' }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        message === 'Usuário ou senha inválidos.' || message === 'As senhas não estão iguais.' || (message === 'Por favor, preencha todos os campos.' && password === '') ?
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <mask id="mask0_34_1183" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                                    <rect width="20" height="20" fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_34_1183)">
                                                    <path d="M8 10.9743C8.11622 10.9743 8.21367 10.935 8.29233 10.8563C8.371 10.7778 8.41033 10.6804 8.41033 10.5642C8.41033 10.4478 8.371 10.3504 8.29233 10.2718C8.21367 10.1932 8.11622 10.1538 8 10.1538C7.88378 10.1538 7.78633 10.1932 7.70767 10.2718C7.629 10.3504 7.58967 10.4478 7.58967 10.5642C7.58967 10.6804 7.629 10.7778 7.70767 10.8563C7.78633 10.935 7.88378 10.9743 8 10.9743ZM7.66667 8.76917H8.33333V4.76917H7.66667V8.76917ZM8.00217 14C7.1725 14 6.39244 13.8426 5.662 13.5277C4.93167 13.2128 4.29633 12.7854 3.756 12.2457C3.21567 11.7059 2.78794 11.0711 2.47283 10.3413C2.15761 9.61167 2 8.83194 2 8.00217C2 7.1725 2.15744 6.39244 2.47233 5.662C2.78722 4.93167 3.21456 4.29633 3.75433 3.756C4.29411 3.21567 4.92889 2.78794 5.65867 2.47283C6.38833 2.15761 7.16806 2 7.99783 2C8.8275 2 9.60756 2.15744 10.338 2.47233C11.0683 2.78722 11.7037 3.21456 12.244 3.75433C12.7843 4.29411 13.2121 4.92889 13.5272 5.65867C13.8424 6.38833 14 7.16806 14 7.99783C14 8.8275 13.8426 9.60756 13.5277 10.338C13.2128 11.0683 12.7854 11.7037 12.2457 12.244C11.7059 12.7843 11.0711 13.2121 10.3413 13.5272C9.61167 13.8424 8.83194 14 8.00217 14Z" fill="#CD4747" />
                                                </g>
                                            </svg>
                                            : null
                                    )
                                }}
                                autoComplete='new-password'
                            />
                        </Box>
                        <Typography sx={{ color: '#52525B', fontSize: '14px', fontFamily: 'Satoshi', marginTop: '8px', marginBottom: 0 }}>Confirmar Senha</Typography>
                        <Box position='relative'>
                            <Box
                                sx={{
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    zIndex: '10',
                                    top: '50%',
                                    right: '33px',
                                    transform: 'translateY(-50%)'
                                }}
                                onClick={() => setShowConfirmPassword(prev => !prev)}
                            >
                                {showConfirmPassword ? <VisibilityOffIcon sx={{ fill: 'gray', width: "16px", height: "16px" }} /> : <VisibilityIcon sx={{ fill: 'gray', width: "16px", height: "16px" }} />}
                            </Box>
                            <TextField
                                placeholder='Confirme sua senha'
                                type={showConfirmPassword ? "text" : "password"}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                sx={{ '& .css-1qb9py0-MuiInputBase-root-MuiOutlinedInput-root': { background: message === 'Usuário ou senha inválidos.' || message === 'As senhas não estão iguais.' || (message === 'Por favor, preencha todos os campos.' && password === '') ? '#F8D6D3' : '#F9F9F9' }, marginTop: '5px', marginBottom: { xs: '8px', lg: '5px' }, borderRadius: '4px' }}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                size="small"
                                InputProps={{
                                    endAdornment: (
                                        message === 'Usuário ou senha inválidos.' || message === 'As senhas não estão iguais.' || (message === 'Por favor, preencha todos os campos.' && password === '') ?
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <mask id="mask0_34_1183" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                                    <rect width="20" height="20" fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_34_1183)">
                                                    <path d="M8 10.9743C8.11622 10.9743 8.21367 10.935 8.29233 10.8563C8.371 10.7778 8.41033 10.6804 8.41033 10.5642C8.41033 10.4478 8.371 10.3504 8.29233 10.2718C8.21367 10.1932 8.11622 10.1538 8 10.1538C7.88378 10.1538 7.78633 10.1932 7.70767 10.2718C7.629 10.3504 7.58967 10.4478 7.58967 10.5642C7.58967 10.6804 7.629 10.7778 7.70767 10.8563C7.78633 10.935 7.88378 10.9743 8 10.9743ZM7.66667 8.76917H8.33333V4.76917H7.66667V8.76917ZM8.00217 14C7.1725 14 6.39244 13.8426 5.662 13.5277C4.93167 13.2128 4.29633 12.7854 3.756 12.2457C3.21567 11.7059 2.78794 11.0711 2.47283 10.3413C2.15761 9.61167 2 8.83194 2 8.00217C2 7.1725 2.15744 6.39244 2.47233 5.662C2.78722 4.93167 3.21456 4.29633 3.75433 3.756C4.29411 3.21567 4.92889 2.78794 5.65867 2.47283C6.38833 2.15761 7.16806 2 7.99783 2C8.8275 2 9.60756 2.15744 10.338 2.47233C11.0683 2.78722 11.7037 3.21456 12.244 3.75433C12.7843 4.29411 13.2121 4.92889 13.5272 5.65867C13.8424 6.38833 14 7.16806 14 7.99783C14 8.8275 13.8426 9.60756 13.5277 10.338C13.2128 11.0683 12.7854 11.7037 12.2457 12.244C11.7059 12.7843 11.0711 13.2121 10.3413 13.5272C9.61167 13.8424 8.83194 14 8.00217 14Z" fill="#CD4747" />
                                                </g>
                                            </svg>
                                            : null
                                    )
                                }}
                                autoComplete='new-password'
                            />
                        </Box>
                        <Grid container alignItems="center" justifyContent="space-between" marginTop='8px'>
                            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checked}
                                            onChange={handleChange}
                                            name="checked"
                                            color="primary"
                                            size="small"
                                            style={{ color: checked ? ThemeColors.purple500 : "lightgray" }}
                                            sx={{ 'PrivateSwitchBase-input css-1m9pwf3': { width: "40px", height: "40px" } }}
                                        />
                                    }
                                    label={
                                        <p style={{ color: "#52525B", fontSize: '14px', fontFamily: 'Satoshi', border: 'none', padding: '2px 0 0' }}>
                                            Mantenha-me conectado
                                        </p>
                                    }
                                />
                            </Grid>
                            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                                <a href="/esqueci-senha" style={{ color: ThemeColors.purple400, textDecoration: 'none', fontSize: '14px', fontFamily: 'Satoshi' }}>Esqueci minha senha</a>
                            </Grid>
                            <Grid container spacing={1} style={{ marginTop: '16px' }}>
                                <Grid item xs={12}>
                                    <Button type="submit" variant="contained"
                                        className={loading ? "button-disabled" : "button-default"}
                                        fullWidth disabled={loading}>
                                        Criar conta
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button variant="outlined" fullWidth onClick={() => navigate("/login")}>
                                        Já tenho uma conta
                                    </Button>
                                </Grid>
                            </Grid>
                            {/* <Box sx={{ width: '100%', display: 'flex', gap: '10px', alignItems: 'center', marginTop: '16px' }}>
                                <Box sx={{ width: '100%', border: '1px solid #dbdbdb', height: '1px' }} />
                                <Typography sx={{ color: "#52525B", fontSize: '16px', fontFamily: 'Satoshi' }}>
                                    Ou
                                </Typography>
                                <Box sx={{ width: '100%', border: '1px solid #dbdbdb', height: '1px' }} />
                            </Box>
                            <Grid container spacing={1} style={{ marginTop: '16px' }}>
                                <Grid item xs={12}>
                                    <Button fullWidth sx={{ border: '1px solid rgb(218, 222, 231)', background: '#fff', color: "#52525B", display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'center', fontWeight: 600 }}>
                                        <GoogleIcon />
                                        Entrar com Google
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button fullWidth sx={{ border: '1px solid rgb(218, 222, 231)', background: '#fff', color: "#52525B", display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'center', fontWeight: 600 }} >
                                        <FacebookIcon />
                                        Entrar com Facebook
                                    </Button>
                                </Grid>
                            </Grid> */}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
};

export default Form;